import r from "lodash/isEmpty";
import t from "lodash/isArray";
import e from "lodash/isObject";

var o = function o(t) {
  return e(t) && r(t);
},
    n = function n(e) {
  return t(e) && r(e);
},
    s = function s(r, t) {
  return r.length === t.length && r.every(function (r, e) {
    var s = t[e];
    return !(!n(r) || !n(s)) || !(!o(r) || !o(s)) || r === s;
  });
},
    i = function i(r) {
  return "object" == typeof r && null !== r && "message" in r && "string" == typeof r.message;
},
    m = function m(r) {
  if (i(r)) return r;

  try {
    return new Error(JSON.stringify(r));
  } catch (t) {
    return new Error(String(r));
  }
},
    a = function a(r) {
  return m(r).message;
},
    g = function g(r) {
  var t = new FormData(r.target);
  return Object.fromEntries(t);
};

export { s as areArrayValuesEqual, a as getErrorMessage, g as getFormDataFromEvent, i as isErrorWithMessage, m as toErrorWithMessage };